import _ from 'lodash';
import {t} from '../../../../../../services/i18n';
import {sortString} from '../../../../../../services/Helpers';
import {
    ALL_CATEGORY_GROUPS_KEY,
    ALL_HUG_TYPES_KEY,
    ALL_KEY,
    ALL_STAFF_KEY,
    ONLY_AVAILABLE_KEY,
} from '../ChooseHug/hugFiltersConfig';

export const getTrackCourseFiltersConfig = ({showCategoryGroupFilter}) => [
    {
        key: 'categoryGroup',
        show: showCategoryGroupFilter,
        defaultValue: ALL_CATEGORY_GROUPS_KEY,
        options: (baseList) => {
            const groups = baseList.map(item => item.box_categories?.box_categories_groups?.[0]).filter(Boolean);
            const unique = _.uniqBy(groups, 'id');
            return [
                {value: ALL_CATEGORY_GROUPS_KEY, label: t('all-category-types')},
                ..._.sortBy(unique, group => sortString(group.name)).map(group => ({
                    value: group.id,
                    label: group.name,
                })),
            ];
        },
        filterFunc: (series, value) =>
            !value
            || value === ALL_CATEGORY_GROUPS_KEY
            || series.box_categories?.box_categories_groups?.[0]?.id === value,
        style: {minWidth: '160px', flex: 1},
        showSearch: true,
    },
    {
        key: 'hugType',
        show: true,
        defaultValue: ALL_HUG_TYPES_KEY,
        options: (baseList) => {
            const categories = baseList.map(item => item.box_categories).filter(Boolean);
            const unique = _.uniqBy(categories, 'id');
            return [
                {value: ALL_HUG_TYPES_KEY, label: t('all-hugim-types')},
                ..._.sortBy(unique, category => sortString(category.name)).map(category => ({
                    value: category.id,
                    label: category.name,
                })),
            ];
        },
        filterFunc: (series, value) =>
            !value || value === ALL_HUG_TYPES_KEY || series.box_categories?.id === value,
        style: {minWidth: '160px', flex: 1},
        showSearch: true,
    },
    {
        key: 'staff',
        show: true,
        defaultValue: ALL_STAFF_KEY,
        options: (baseList) => {
            const coaches = [
                ...baseList.map(item => item.coach).filter(Boolean),
                ...baseList.map(item => item.second_coach).filter(Boolean),
            ];
            const unique = _.uniqBy(coaches, 'id');
            return [
                {value: ALL_STAFF_KEY, label: t('all-staff-members')},
                ..._.sortBy(unique, coach => sortString(`${coach.first_name} ${coach.last_name}`))
                    .map(coach => ({
                        value: coach.id,
                        label: `${coach.first_name} ${coach.last_name || ''}`,
                    })),
            ];
        },
        filterFunc: (series, value) =>
            !value
            || value === ALL_STAFF_KEY
            || series.coach?.id === value
            || series.second_coach?.id === value,
        style: {minWidth: '160px', flex: 1},
        showSearch: true,
    },
    {
        key: 'availability',
        show: true,
        defaultValue: ALL_KEY,
        options: [
            {value: ONLY_AVAILABLE_KEY, label: t('only-available-hugim-from-track')},
            {value: ALL_KEY, label: t('all-hugim-from-track')},
        ],
        filterFunc: (series, value) => value !== ONLY_AVAILABLE_KEY || !series.isHugFull,
        style: {minWidth: '180px', flex: 1},
    },
];
